<template>
  <div class="appointment-card px-2" @click="selectPatient(patient_id, $event)" :class="{highlight:isUpsell}">
    <div class="overflow-hidden align-items-center flex-column h-100 d-flex">
      <div class="text-center flex-grow-1 d-flex align-items-center">
        <div style="font-size: .875rem; line-height: 0.9rem">
          <span class="patient-name text-nowrap font-weight-bolder" :title="patient">{{ patient }}</span>
          <br />
          <small class="time d-block mt-2">{{ isUpsell ? 'With our integration' : moment(datetime).format('LT') }}</small>
        </div>
      </div>
    </div>
    <div class="overlay h-100 d-flex align-items-center" v-if="isLoading">
      <div class="mx-auto">
        <font-awesome-icon icon="spinner-third" spin class="text-info" />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState, mapGetters } from 'vuex'
import { IntegrationApi, PatientApi } from '@/services'
export default {
  props: [
    'id',
    'patient',
    'patient_id',
    'status',
    'datetime',
    'when',
    'isSelectable',
    'isUpsell',
  ],
  data() {
    return {
      isLoading: false,
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('tour', ['activeTour']),
    ...mapGetters('tour', ['mockPatient']),
    ...mapGetters('auth', ['isIntegrationActive']),
  },
  async mounted() {},
  methods: {
    async selectPatient(id, event) {
      if (this.isLoading || !this.isSelectable) return
      this.isLoading = true
      let name = this.patient.split(' ')
      let isMiddle = name.length > 2
      let p = {
        id,
        firstname: name[this.activeTour ? 0 : 1],
        middlename:
          (isMiddle &&
            name.reduce((a, c, i) => {
              if (i > 1) a += ' ' + c
              return a
            }, '')) ||
          '',
        lastname: name[this.activeTour ? 1 : 0],
      }
      if (this.activeTour) {
        this.isLoading = false
        this.$emit('selected', { ...this.mockPatient, ...p })
        return
      }
      this.$emit('selected', p, event)
      if (!this.isIntegrationActive) {
        this.isLoading = false
        return
      }
      try {
        let patient = await PatientApi.get('sikka-patient/' + this.patient_id)
        this.$emit('selected', patient, event)
      } catch (err) {}
      this.isLoading = false
    },
  },
}
</script>

<style scoped>
.appointment-card {
  border: 1px solid var(--border-color);
  height: 100%;
  cursor: pointer;
  position: relative;
  color: #272348;
  border-radius: 5px;
}
.appointment-card.selected {
  cursor: inherit;
  background: var(--primary-color-20);
  border: 1px solid var(--primary-color);
}
.appointment-card:hover:not(.selected) {
  /* border: 1px solid var(--primary-color); */
  border: 0;
  border-radius: 0;
  border-bottom: 2px solid var(--primary-color);
}
.appointment-card .time {
  color: var(--secondary-color);
  margin-top: 0.5em;
  display: block;
}
.overlay {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: #ffffff60;
  /* display: none; */
}
/* .appointment-card.selected .overlay {
  display: block;
} */

.appointment-card.highlight {
  background: var(--primary-color-20);
  border: 1px solid var(--primary-color);
}
.appointment-card.highlight small {
  color: var(--primary-color);
  font-weight: bold;
}

.patient-name {
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
